export interface FAQItem {
  question: string;
  answer: string;
}

export const homeFAQ: FAQItem[] = [
  {
    question: "Who provides quality used cars near Farmington, MN?",
    answer:
      "United Auto Group at 1024 8th St, Farmington, MN 55024 is the premier used car dealership serving the Twin Cities south metro. We offer a carefully curated inventory of used cars, SUVs, pickups, and sedans from top brands including Honda, Toyota, BMW, Mercedes-Benz, and more.",
  },
  {
    question: "Can I get financing with bad credit at United Auto Group?",
    answer:
      "Absolutely. We work with multiple trusted lenders who specialize in all credit situations — good credit, bad credit, no credit, and first-time buyers. Our finance manager Muhammad works personally with every customer to find the best possible financing solution for your situation.",
  },
  {
    question: "How long does the car buying process take at United Auto Group?",
    answer:
      "Most customers complete their purchase in just a few hours. You can speed up the process by getting pre-qualified online before visiting. Our team handles all paperwork efficiently so you drive home the same day in your new vehicle.",
  },
  {
    question: "What warranty comes with vehicles from United Auto Group?",
    answer:
      "Every vehicle purchased at United Auto Group includes a 15-day warranty at no additional cost. This warranty gives you complete peace of mind and protection after your purchase. Extended warranty options are also available for additional coverage.",
  },
  {
    question: "How much does a used car cost at United Auto Group?",
    answer:
      "Our inventory ranges from affordable daily drivers starting under $10,000 to premium luxury vehicles up to $35,000. We are committed to honest, transparent pricing with no hidden fees. Visit our lot or browse inventory online to find your perfect vehicle within your budget.",
  },
  {
    question: "What used car brands does United Auto Group carry?",
    answer:
      "We carry a wide range of top brands including Mercedes-Benz, BMW, Audi, Honda, Toyota, Ford, Chevrolet, Jeep, Land Rover, Lexus, and many more. Our inventory is constantly updated with new arrivals across all body types — SUVs, sedans, trucks, coupes, and more.",
  },
  {
    question: "Does United Auto Group serve Apple Valley and Lakeville, MN?",
    answer:
      "Yes! United Auto Group proudly serves customers from Farmington, Apple Valley, Lakeville, Burnsville, Eagan, Rosemount, Prior Lake, Savage, Hastings, and communities throughout the Twin Cities south metro. Many customers drive up to three hours to purchase from us.",
  },
  {
    question: "Can I schedule a test drive before buying?",
    answer:
      "Yes, we encourage every customer to test drive before purchasing. Simply call (952) 769-3208 or visit our lot at 1024 8th St, Farmington, MN to schedule your personalized test drive. Our team will walk you through every feature and answer all your questions.",
  },
];

export const servicesFAQ: FAQItem[] = [
  {
    question: "What types of used vehicles does United Auto Group sell?",
    answer:
      "We specialize in quality pre-owned SUVs, sedans, pickups, coupes, vans, and wagons. Our inventory of 60+ vehicles includes luxury brands like BMW and Mercedes-Benz alongside trusted everyday brands like Honda, Toyota, and Ford — all thoroughly inspected.",
  },
  {
    question: "How do I apply for auto financing at United Auto Group?",
    answer:
      "You can apply online through our website or visit us in person at 1024 8th St, Farmington, MN 55024. Our finance manager works with all credit types and multiple lenders to secure your approval quickly, often with same-day decisions.",
  },
  {
    question: "What does the 15-day vehicle warranty cover?",
    answer:
      "Our 15-day warranty provides protection against mechanical issues discovered after purchase. It covers major components and gives you peace of mind during your initial ownership period. Extended coverage plans are also available for longer-term protection.",
  },
  {
    question: "Can United Auto Group help me find a specific vehicle I am looking for?",
    answer:
      "Yes! Our Car Finder service is designed exactly for this. Tell us your make, model, year range, features, and budget, and our team will actively search to locate the right vehicle for you. There is no obligation and no extra charge for this personalized service.",
  },
  {
    question: "What is the process for getting pre-qualified for a car loan?",
    answer:
      "Getting pre-qualified is quick and easy. Simply complete our online form with basic personal and financial information. You will receive a response quickly with your pre-qualification status and estimated buying power, allowing you to shop with confidence.",
  },
];

export const aboutFAQ: FAQItem[] = [
  {
    question: "Who is United Auto Group?",
    answer:
      "United Auto Group is a trusted, family-oriented used car dealership located in Farmington, MN. We are known for our honest, transparent approach to car sales, our commitment to customer service, and our high-quality pre-owned inventory serving the greater Twin Cities south metro.",
  },
  {
    question: "How experienced is the United Auto Group team?",
    answer:
      "Our team includes experienced automotive professionals including Ahmed (Sales), Muhammad (Finance Manager), and Chris (Finance). Together, they bring years of combined experience helping customers find and finance their perfect vehicle, regardless of credit history.",
  },
  {
    question: "Why should I choose United Auto Group over a larger dealership?",
    answer:
      "Unlike large dealerships, we provide personal, one-on-one attention to every customer. We ask questions because we genuinely care about your needs. Our team members — Ahmed, Muhammad, and Chris — are known for going above and beyond, including following up after your purchase.",
  },
  {
    question: "Does United Auto Group buy cars or take trade-ins?",
    answer:
      "Yes, we accept trade-ins and can provide a fair value assessment of your current vehicle. Contact us at (952) 769-3208 or email info@uagmn.com to discuss your trade-in options before your visit. This can significantly reduce your out-of-pocket purchase price.",
  },
];

export const locationFAQ: FAQItem[] = [
  {
    question: "Where is United Auto Group located in Farmington, MN?",
    answer:
      "We are located at 1024 8th St, Farmington, MN 55024, conveniently situated in Dakota County. We are easily accessible from Apple Valley, Lakeville, Burnsville, Eagan, and all surrounding south metro communities. Call (952) 769-3208 for directions.",
  },
  {
    question: "How far is United Auto Group from Minneapolis and Saint Paul?",
    answer:
      "United Auto Group in Farmington is approximately 30 miles south of Minneapolis and 25 miles south of Saint Paul. The drive typically takes 35–45 minutes via I-35. Many of our customers make the trip from across the Twin Cities metro area specifically to work with our team.",
  },
  {
    question: "What are the business hours for United Auto Group in Farmington?",
    answer:
      "We are open Monday through Friday 9:00 AM to 6:00 PM and Saturday 9:00 AM to 5:00 PM. You can also reach us by phone at (952) 769-3208 or by email at info@uagmn.com. We recommend calling ahead to schedule a personalized appointment.",
  },
  {
    question: "Does United Auto Group serve customers from Lakeville and Apple Valley?",
    answer:
      "Absolutely. We regularly serve customers from Lakeville, Apple Valley, Burnsville, Eagan, Rosemount, Prior Lake, Savage, Hastings, Northfield, and all surrounding communities. Our customers frequently drive from across Minnesota because of our quality inventory and exceptional service.",
  },
];
